export default __webpack_public_path__ + "static/media/tovie-logo--dark.63823aec.svg";